(function (app) {

    app.constant("prefillCategories",
    [
        { Label: "Owner", Value: "Owner" },
        { Label: "Joint Owner", Value: "JointOwner" },
        { Label: "Primary Beneficiary", Value: "PrimaryBeneficiary" },
        { Label: "Annuitant", Value:"Annuitant" },
        { Label: "Joint Annuitant", Value:"JointAnnuitant" },
        { Label: "Contingent Beneficiary", Value: "ContingentBeneficiary"}
    ]);

})(window.app); //jshint ignore:line